const tlid = (state = { likeid: '', likeurl: '' }, action) => {
  switch (action.type) {
    case 'SAVE_LIKE_ID':
      return {
        ...state,
        likeid: action.likeid,
        likeurl: action.likeurl
      };
    default:
      return state;
  }
};

export default tlid;



/** WEBPACK FOOTER **
 ** ./src/reducers/id.js
 **/